<template>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <div id="container-blog">
        <h1>
            Blog
        </h1>
        <iframe src="https://educatedspending.wordpress.com/" width="90%" height="600" id="spotify-emd" frameBorder="0"></iframe>

    </div>
</template>

<script>
export default {
    name: "Blog"
}
</script>

<style scoped>
     #container-blog {
        background-color: black;
        height: 100%;
        margin-top: 0%;
        padding: 3%;
    }

    #h1{
        font-size: 36px;
        color: white;
        text-align: center;
        font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
    }
</style>